import React, { useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { MapContainer, TileLayer, Marker, Popup , Circle} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";
import L from 'leaflet';
import MarkerClusterGroup from "react-leaflet-markercluster";
import placeDesktop from './imagens/placeIcon1.png'
import placeVm from './imagens/placeIcon3png.png'
import PlaceNotebook from './imagens/placeIcon2png.png'


let iconeDesktop = L.icon({
  iconUrl: placeDesktop,

  iconSize: [38, 42],
});

let iconeVm = L.icon({
  iconUrl: placeVm,

  iconSize: [38, 42],
});

let iconeNotebook = L.icon({
  iconUrl: PlaceNotebook,

  iconSize: [38, 42],
});



let IconRevenda = L.icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]

});



export default function VisaoParqueInventoryMaps(props) {

    const [open, setOpen] = useState(false);

 
    const customHeader = (
        <div className="flex align-items-center gap-2">           
            <span className="font-bold text-xl">DATACOUNT INVENTORY - POSIÇÃO DE EQUIPAMENTOS</span>
        </div>
    );

    const converteDataToIso = (isoString) =>{
      const date = new Date(isoString);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
      
    }

const  renderClasse = (dataatualizacao) => {
        // Converte a data de entrada para o objeto Date
        const data1 = new Date(dataatualizacao);

        const dataAtual = new Date(); // Data atual    
        // Calcula a diferença em milissegundos
        const diffMilissegundos =  dataAtual - data1;    
        // Convertendo a diferença
        const diffSegundos = Math.floor(diffMilissegundos / 1000); 
                  // Segundos
        const diffMinutos = Math.floor(diffSegundos / 60);    
                       // Minutos
        const diffHoras = Math.floor(diffMinutos / 60); 
                             // Horas
        const diffDias = Math.floor(diffHoras / 24);                        // Dias    
        // Calculando a diferença exata em cada unidade
        const diasRestantes = diffDias;

        const horasRestantes = diffHoras % 24;

        const minutosRestantes = diffMinutos % 60;

        const segundosRestantes = diffSegundos % 60;    

        return diasRestantes

  }


  const fillBlueOptions = { fillColor: 'blue',  }

  const renderIcone = (type) =>{
    switch(type){
      case 'Desconhecido' : return iconeDesktop;
      case 'Virtual Machine' : return iconeVm;
      case 'Desktop' : return iconeDesktop;
      case 'Notebook' : return iconeNotebook;
      default: return iconeDesktop;
    }

  }

  


  
  return (
    <>
      <Button
        icon="pi pi-map"
        className="p-button-secondary p-button-sm"
        onClick={() => setOpen(true)}
        tooltip="Visualizar Mapa"
        tooltipOptions={{ position: 'bottom' }}
        Button       
      />

      <Sidebar
        header={customHeader} 
        onHide={() => setOpen(false)}
        style={{ width: '70vw' }}
        visible={open}
        position="right"
        className="custom-sidebar"
        maximizable
        {...props}
      >
        <MapContainer
          center={[props.dataEmpresa.latitude, props.dataEmpresa.longitude]}
          zoom={9}
          minZoom={5}   // limite mínimo
          maxZoom={15}
          scrollWheelZoom={true}
          style={{ height: '100%', width: '100%' }} // importante definir altura
        >
          <TileLayer
            attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          {
            
          }
           <Circle 
              center={[props.dataEmpresa.latitude, props.dataEmpresa.longitude]} 
              pathOptions={fillBlueOptions}color="transparent"   // evita borda visível
              stroke={false} fillOpacity={0.2} radius={props.dataEmpresa?.raio ? props.dataEmpresa.raio * 100 : 1000} />
           <Marker 
                  icon={IconRevenda}                 
                  position={[props.dataEmpresa.latitude, props.dataEmpresa.longitude]}                                        
                ></Marker>
          <MarkerClusterGroup 
                maxClusterRadius={50}>
                  {
                    props.positions && props.positions.map((posicao, i) => {
                        // Garante que Posicao existe antes de acessar
                        let latitude = posicao?.Posicao?.latitude 
                            ? parseFloat(posicao.Posicao.latitude) 
                            : null;

                        let longitude = posicao?.Posicao?.longitude 
                            ? parseFloat(posicao.Posicao.longitude) 
                            : null;

                        return (latitude && longitude) ? (
                            <Marker 
                              key={'revenda' + i}                   
                              position={[latitude, longitude]}         
                              icon={renderIcone(posicao.devicetype)}    

                            >
                            <Popup minWidth={350}>
                                
                                <div style={{ width: '100%' }}>

                                  <div style={{fontSize : '12px'}}><span><strong>Cliente</strong>: {posicao.razaoSocial}</span></div>
                                  <hr style={{width : '100%', height :'0.5px', backgroundColor : '#ccc', border :' none'}}/>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>Modelo</strong>: {posicao.Modelo.Model}</span></div>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>Tipo</strong>: {posicao.devicetype}</span></div>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>Marca</strong>: {posicao.Modelo.Manufacturer}</span></div>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>S. Operacional</strong>: {posicao.OperatingSystem.Name}</span></div>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>Hostname</strong>: {posicao.hostName}</span></div>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>Atualização</strong>: {converteDataToIso(posicao.dataAtualizacao)}</span></div>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>DCA</strong>: {posicao.chaveDca}</span></div>
                                  <div style={{fontSize : '10px', paddingTop  : '5px'}}><span><strong>ID</strong>: {posicao._id}</span></div>
                                  
                                </div>

                            </Popup>
                            </Marker>
                        ) : null;
                        })

                  }
          </MarkerClusterGroup> 
        </MapContainer>
      </Sidebar>

    </>
  );
}
